import { useTestIds } from "@homebound/beam";
import { pluralize } from "src/utils";
import {
  OptionsTooltip_ReadyPlanOptionFragment,
  OptionsTooltip_ReadyPlanOptionGroupFragment,
} from "./OptionsTooltipContent.generated";

/** An option (or option group) referenced by another option, i.e. as a prerequisite or conflict. */
export type TooltipOption = OptionsTooltip_ReadyPlanOptionFragment | OptionsTooltip_ReadyPlanOptionGroupFragment;

type OptionsTooltipContentProps = { label: string; options: TooltipOption[] };

/** Lists the referenced options for the prerequisite/conflict tags, i.e. `2 Conflicts:` and a line per option. */
export function OptionsTooltipContent(props: OptionsTooltipContentProps) {
  const { label, options } = props;
  const tid = useTestIds(props, "optionsTooltip");
  return (
    <div {...tid}>
      <div>{`${pluralize(options, label)}:`}</div>
      {options.map((o) => (
        <div key={o.id} {...tid.option}>
          {formatTooltipOption(o)}
        </div>
      ))}
    </div>
  );
}

/** I.e. `OPT1 Upgraded Cabinets (Level 1 > Kitchen)`, or just `Cabinet Hardware (Level 1 > Kitchen)` for groups. */
export function formatTooltipOption(option: TooltipOption) {
  const { name, readyPlanLocation } = option;
  // Only options have codes, option groups don't
  const code = "code" in option ? option.code : undefined;
  const location = readyPlanLocation?.location.displayLocationPath;
  return [code, name, location && `(${location})`].compact().join(" ");
}
